import * as React from 'react'
import classnames from 'classnames'

import cls from './scroll.module.scss'

class UikScrollArea extends React.PureComponent<UikScrollAreaProps> {
  render() {
    const { children, className, ...rest } = this.props
    return (
      <div className={classnames(cls.wrapper, className)} {...rest}>
        {children}
      </div>
    )
  }
}

UikScrollArea.defaultProps = {
  className: null,
  children: null,
}

export default UikScrollArea
